export const CANONICAL_ORIGIN = "https://www.howisthe.surf";

export function normalizeCanonicalPath(pathname: string): string {
  const [pathOnly] = pathname.split(/[?#]/);
  const withLeadingSlash = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  const withoutTrailingSlash =
    withLeadingSlash.length > 1 ? withLeadingSlash.replace(/\/+$/, "") : withLeadingSlash;

  return withoutTrailingSlash || "/";
}

export function getCanonicalUrl(pathname: string): string {
  return `${CANONICAL_ORIGIN}${normalizeCanonicalPath(pathname)}`;
}
